module.exports = __webpack_public_path__ + "img/CTA Arrow.c3fe3a62.svg";